
import { defineComponent } from '@nuxtjs/composition-api';
import AutocompleteDropdownV2 from '@/components/common/AutocompleteDropdownV2.vue';
import PlusIcon from '@/assets/svg/plus.vue.svg';
import EducationHistoryDegreesQuery from '@/components/partials/public-portfolio/PublicPortfolioEducationHistory/apollo/EducationHistoryDegrees.query';

type Item = { value: string; name?: string };

const DEFAULT_ITEMS: Array<Item> = [
  { value: 'Associate degree' },
  { value: 'Bachelor’s degree' },
  { value: 'Master’s degree' },
  { value: 'PhD' },
  { value: 'Highschool Diploma' },
  { value: 'Certificate' },
  { value: 'Specialization course' },
  { value: 'Training' },
];

export default defineComponent({
  name: 'PublicPortfolioEducationHistoryDegree',
  components: {
    AutocompleteDropdownV2,
    PlusIcon,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  apollo: {
    cities: {
      query: EducationHistoryDegreesQuery,
      variables() {
        return {
          search: this.query,
        };
      },
      update(data) {
        this.items = data.universityDegrees.map((item: string) => ({ value: item }));
      },
      skip() {
        return !this.query || !this.changed;
      },
      debounce: 500,
      fetchPolicy: 'network-only',
    },
  },
  data(): { query: string; items: Array<Item>; changed: boolean } {
    return {
      query: this.value,
      items: [],
      changed: false,
    };
  },
  computed: {
    suggestions() {
      if (!this.query) return DEFAULT_ITEMS;
      return this.items;
    },
    canAddNew() {
      return Boolean(this.query);
    },
  },
  methods: {
    handleQuery({ value: query }: Item) {
      this.changed = true;
      this.query = query;
    },

    handlePush({ value, name }: Item) {
      this.$emit('input', value || name);
      if (name) {
        this.items.push({ value: name });
      }
    },
  },
});
